import ApiClient from './ApiClient';

export default class ApiArea {
    static getAreas = () => {
        return ApiClient.get({
            url: '/api/admin/device_areas',
        });
    }

    static updateArea = (areaId, data) => {
        return ApiClient.patch({
            url: '/api/admin/device_areas/' + areaId,
            body: data
        });
    }

    static addArea = (data) => {
        return ApiClient.post({
            url: '/api/admin/device_areas',
            body: data
        });
    }

    static removeArea = (areaId) => {
        return ApiClient.del({
            url: '/api/admin/device_areas/' + areaId,
        });
    }

    static getArea = (areaId) => {
        return ApiClient.get({
            url: '/api/admin/device_areas/' + areaId,
        });
    }

    static addAreaDevice = (areaId, deviceId) => {
        return ApiClient.post({
            url: '/api/admin/device_areas/' + areaId + '/device/' + deviceId,
        });
    }

    static removeAreaDevice = (areaId, deviceId) => {
        return ApiClient.del({
            url: '/api/admin/device_areas/' + areaId + '/device/' + deviceId,
        });
    }

}



// WEBPACK FOOTER //
// ./src/services/ApiArea.js